/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_viewer = {
    readonly promoCodeMessaging: boolean | null;
    readonly " $refType": "messageHelpers_viewer";
};
export type messageHelpers_viewer$data = messageHelpers_viewer;
export type messageHelpers_viewer$key = {
    readonly " $data"?: messageHelpers_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"messageHelpers_viewer">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_viewer"
};
(node as any).hash = '3c33d31c1d6ce7266a596e6d9bbe6f23';
export default node;
